import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../../../_models';

@Component({
  selector: 'header-account-menu',
  templateUrl: './header-account-menu.component.html',
  styleUrls: ['./header-account-menu.component.scss'],
})
export class HeaderAccountMenuComponent {
  @Input() user: User = new User();
  @Input() showName = true;
  /** Set by the header when this user may open the sandbox; null hides the item. */
  @Input() sandboxUrl: string | null = null;

  @Output() logoutClick = new EventEmitter<void>();
  @Output() shadowToggle = new EventEmitter<void>();

  get initials(): string {
    const f = (this.user?.first_name || '').charAt(0);
    const l = (this.user?.last_name || '').charAt(0);
    return (f + l).toUpperCase();
  }

  onLogout(): void { this.logoutClick.emit(); }
  onShadow(): void { this.shadowToggle.emit(); }
}
